/**
 * Fetch root comments (parentId is null) for a given roadmap item.
 * Mirrors Flutter RoadmapRepository.getComments(roadmapItemId, null, ...)
 * (lib/presentation/bottom_sheet/roadmap_comments_bottom_sheet.dart:269-299).
 */

import {
  RoadmapCommentService,
  type RoadmapCommentsPage,
} from '@/domain/services/roadmapComment/roadmapCommentService';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';
import type { PageCursor } from '@/data/types/json';

export class FetchRoadmapRootCommentsUseCase {
  constructor(private service = RoadmapCommentService.getInstance()) {}

  async execute(
    roadmapItemId: string,
    cursor?: PageCursor,
    limit: number = SERVER_FETCH_CONSTANTS.MESSAGES_LIST_PAGINATION,
  ): Promise<RoadmapCommentsPage> {
    return this.service.fetchComments(roadmapItemId, null, limit, cursor);
  }
}

export const fetchRoadmapRootCommentsUseCase = new FetchRoadmapRootCommentsUseCase();
